<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-heading">
      <h5>
        Channel Type Overview
      </h5>
    </div>

    <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

    <div v-else class="panel-body">
      <div class="row" v-if="result.length">
        <div class="col-xs-16">
          <ChannelTypeTable :target-metric="targetMetric" :result="result"/>
        </div>

        <div class="col-xs-8">
          <ChannelTypeChart :loading="loading" :result="result"/>
        </div>
      </div>

      <div v-else class="text-center text-muted" style="margin: 22px 0">
        There is no data to display!
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import SaveHeight from '@/mixins/SaveHeight'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import ChannelTypeChart from "./ChannelTypeChart.vue";
import ChannelTypeTable from "./ChannelTypeTable.vue";

export default {
  components: {ChannelTypeTable, ChannelTypeChart, LoadingSpinner},

  mixins: [SaveHeight],

  props: ['year', 'targetMetric'],

  data() {
    return {
      result: null,
      loading: true,
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    year() {
      this.load()
    },

    targetMetric() {
      this.load()
    }
  },

  methods: {
    load() {
      this.saveHeight()

      this.loading = true

      http.post('/api/v1/reports/channel-types', {year: this.year})
          .then(response => {
            this.result = response.data.data

        this.loading = false
      })
    }
  }
}
</script>
